import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { and, or } from 'ramda';
import { useResponsive } from '../../../shared/hooks';
import { ContainerStyled, HeaderOverlayStyled } from './styles';

export const MainContainer = ({ overlayHeaderMobile = false, children }) => {

  const { xs, sm } = useResponsive();
  const [showHeaderOverlay, setShowHeaderOverlay] = useState(false);

  useEffect(() => {
    setShowHeaderOverlay( and( or(xs,sm), overlayHeaderMobile ));
  }, [xs, sm, overlayHeaderMobile]);

  return (
    <>
      {
        showHeaderOverlay && <HeaderOverlayStyled />
      }
      <ContainerStyled type={'fluid'} showHeaderOverlay={showHeaderOverlay} >
        { children }
      </ContainerStyled>
    </>
  );
};

MainContainer.propTypes = {
  children: PropTypes.any,
  type: PropTypes.string,
};
